import { useFeatureFlagPayload } from '@posthog/react';

export default function PostHogTools() {
  const payload = useFeatureFlagPayload('show-frontend-flag');

  return (
    <div className="flex flex-col space-y-4 mb-8">
      <div className="text-lg font-medium">PostHog Tools</div>
      {/* <div>
        <MajorHeading tooltip="Allows resetting Product Tours">Reset PostHog User</MajorHeading>
        <Button onClick={resetPosthog}>Reset</Button>
      </div> */}

      <div className="flex flex-col space-y-4 text-sm">
        <div className="text-base font-medium">Feature Flag Demo</div>
        <p>{JSON.stringify(payload || 'No payload')}</p>
        <a
          href="https://us.posthog.com/project/297075/feature_flags/498120"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-50 underline hover:text-blue-60"
        >
          Modify flag values
        </a>
      </div>
    </div>
  );
}
